module.exports = __webpack_public_path__ + "images/0b38a6f5cdd09ab697abbd92fba1eb7e.webp";